"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handler = void 0;
var isLocal = process.env.NODE_ENV !== 'production';
var envDic = {
    test: 'test',
    staging: 'staging',
    production: 'production',
    dev: 'dev',
};
var localEnv = envDic[process.env.LOCAL_ENV || 'test'] || 'test';
exports.handler = {
    hostname: window.location.hostname,
    env: isLocal ? localEnv : (window.location.hostname.match(/^.*?\.(\w+)\.zhongbaounion.com$/) || [])[1] || 'production',
    version: isLocal ? '' : (window.location.hostname.match(/^((.*)-)?([^-]+)\.\w+\.zhongbaounion\.com$/) || [])[2] || '',
    isLocal: function () {
        return process.env.NODE_ENV !== 'production';
    },
    isProd: function () {
        return this.env === 'production';
    },
    isTest: function () {
        return this.env === 'test';
    },
    isStaging: function () {
        return this.env === 'staging';
    },
    getEnv: function () {
        return this.env;
    },
    getVersion: function () {
        return this.version;
    },
    getDomain: function (projectName) {
        var versionStr = this.version ? this.version + "-" : '';
        var envStr = this.isProd() ? '' : "." + this.env;
        return "//" + versionStr + projectName + envStr + ".zhongbaounion.com";
    },
    getWechatOauthRedirectUri: function (url) {
        if (this.isProd()) {
            return encodeURIComponent(url);
        }
        else {
            var transferOrigin = 'https://wechatoauth.zhongbaounion.com';
            return encodeURIComponent(transferOrigin + "/?url=" + encodeURIComponent(url));
        }
    },
};
exports.default = exports.handler;
